module.exports = __webpack_public_path__ + "img/inq-ttl-shd.f77d11b5.png";